import { render } from "./cpt-calendar-option.vue?vue&type=template&id=634bb0ac"
import script from "./cpt-calendar-option.vue?vue&type=script&lang=js"
export * from "./cpt-calendar-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__